// extracted by mini-css-extract-plugin
export var editButton = "_mx-0";